import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectionStrategy, ViewChild, AfterViewInit, Renderer2, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { AudioEventService } from './audioEvent.service';
import { Section } from './section.model';
import { finalize, Subscription } from 'rxjs';
import { TopicsService } from '@icullen/api/site';
import { FeatureFlagService } from '@icullen/api/shared';

@Component({
  selector: 'document-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SectionComponent implements AfterViewInit {
  @Input() section: Section;
  @Input() uniqueNumber: string;
  @Input() documentType: string;
  @Input() showSectionName: boolean;
  @Input() isMobile = true;
  @Input() tabName: string;
  @Input() sections: number;
  @Input() followedTopicsMap: Map<string, boolean>;
  @Input() user: string;

  @ViewChild('answerContainer') container;

  constructor(
    private audioEventService: AudioEventService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private topicsService: TopicsService,
    public featureFlagService: FeatureFlagService
  ) {}

  ngAfterViewInit(): void {
    if (this.container) {
      this.audioEventService.addEventListeners(this.container, this.renderer, {
        uniqueNumber: this.uniqueNumber,
        documentType: this.documentType,
      });
    }
  }

  syncScrollTableElements(tableElements: string) {
    const head = document.getElementById('TableHeader');
    const body = document.getElementById('TableBody');
    if (tableElements === 'TableHeader') {
      body.scrollLeft = head?.scrollLeft;
    } else if (body?.scrollLeft) {
      head.scrollLeft = body?.scrollLeft;
    }
  }

  displaySectionName(documentType) {
    if (
      documentType === 'TRACKER' ||
      documentType === 'CJEU_CASE' ||
      documentType === 'COUNTRY_PROFILE' ||
      documentType === 'COMPETITION_LAW_DOC' ||
      documentType === 'STATE_AID' ||
      documentType === 'IOT_PROFILE' ||
      documentType === 'DMA_CASE'
    ) {
      return true;
    }
  }

  isFlash(documentType) {
    if (
      documentType === 'BIG5' ||
      documentType === 'CJEU_CASE' ||
      documentType === 'FLASH' ||
      documentType === 'NOTE' ||
      documentType === 'REGULATORYREPORT' ||
      documentType === 'BIG5_SECTION' ||
      documentType === 'STATE_AID'
    ) {
      return true;
    }
  }
}
